/**
 * Query-parameter prefill readers shared by the V2 modules. Every surface that
 * can be linked to with a known customer reads the same params, so the parsing
 * lives here rather than being reimplemented per module.
 *
 * All of these return `''` on the server: there is no `window` to read. A
 * server-rendered consumer must pass the value it already knows as a prop
 * instead of relying on the self-read, or the server and client renders
 * disagree and hydration mismatches.
 */

function readParam(name: string): string {
  if (typeof window === 'undefined') {
    return '';
  }
  return new URLSearchParams(window.location.search).get(name) ?? '';
}

/** The `?email=` prefill. */
export function readEmailFromQueryParam(): string {
  return readParam('email');
}

/** The `?name=` / `?phoneNumber=` prefill for the registration step. */
export function readNamePhoneFromQueryParams(): { fullName: string; phoneNumber: string } {
  return {
    fullName: readParam('name').trim(),
    // Trimmed because a literal `+` in a query string decodes to a space. The
    // field formats this for display on its own.
    phoneNumber: readParam('phoneNumber').trim(),
  };
}
